import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import {
  Button,
  ButtonsWrapper,
  ICONS,
  Loader,
  Modal,
  PageLayout,
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';
import { PLATFORM_PERMISSIONS, PERMISSION_ACTIONS } from '@thinknet-gmbh/platform-common';

import { useRouteQuery } from 'src/common/helpers';
import { useGetJobById } from 'src/hooks/jobs/get-job-by-id.hook';
import { VacanciesForm } from 'src/pages/vacancies/components/vacancies-form';
import PermissionCheck from 'src/components/permission-check';

import { JobDetailsEdit } from './components/job-details-edit';
import { JobDetailsView } from './components/job-details-view';
import { HeaderContainer } from './job-details-page.styles';

const JobDetailsPage = () => {
  const { t } = useTranslation(['common', 'jobs']);
  const [isEdit, setIsEdit] = useState(false);
  const [isOpenedCreateVacancy, setIsOpenedCreateVacancy] = useState(false);

  const { state } = useLocation();
  const query = useRouteQuery();
  const id: string = query.get('id') || '';

  const { job, loading } = useGetJobById(id);

  const closeModal = () => {
    setIsOpenedCreateVacancy(false);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <PageLayout pageTitle={t('jobs:labels.jobProfile')}>
      <Modal
        isOpened={isOpenedCreateVacancy}
        title={t('jobs:labels.addNewVacancy')}
        onClose={closeModal}
      >
        <VacanciesForm
          onSuccess={closeModal}
          onClose={closeModal}
          isModal
          initialValues={{
            companyId: state.companyId,
            departmentId: state.departmentId,
            jobId: id,
          }}
        />
      </Modal>
      <HeaderContainer>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {isEdit ? 'Edit job' : t('jobs:labels.jobProfile')}
        </Typography>
        {!isEdit && (
          <ButtonsWrapper>
            <PermissionCheck
              permission={PLATFORM_PERMISSIONS.jobManagement}
              action={PERMISSION_ACTIONS.update}
              createdBy={job.createdBy}
            >
              <Button
                type="primary"
                ghost
                icon={ICONS.playCircle}
                iconColor={PLATFORM_THEME_COLORS.primary.blue}
                onClick={() => setIsOpenedCreateVacancy(true)}
              >
                {t('jobs:labels.startVacancyProcess')}
              </Button>
            </PermissionCheck>
            <PermissionCheck
              permission={PLATFORM_PERMISSIONS.jobManagement}
              action={PERMISSION_ACTIONS.update}
              createdBy={job.createdBy}
            >
              <Button
                type="primary"
                ghost
                icon={ICONS.editAlt}
                iconColor={PLATFORM_THEME_COLORS.primary.blue}
                onClick={() => setIsEdit(true)}
              >
                {t('common:buttons.edit')}
              </Button>
            </PermissionCheck>
          </ButtonsWrapper>
        )}
      </HeaderContainer>
      {isEdit ? (
        <JobDetailsEdit initialValues={job} onCancel={() => setIsEdit(false)} />
      ) : (
        <JobDetailsView job={job} />
      )}
    </PageLayout>
  );
};

export default JobDetailsPage;
